import React, { useMemo } from "react";
import { PeekInputSelect } from "@piiqtechnologies/ui-components";
import { Plans } from "@constants/Plans";
const CommunityPlanSelector = (props) => {
    const userPlans = [Plans.TOTAL_LEASING, Plans.LEASING_3D, Plans.MARKETING_SUITE];
    const selectPlan = useMemo(() => userPlans === null || userPlans === void 0 ? void 0 : userPlans.map((type) => ({ id: type, name: type })), [userPlans]);
    return React.createElement(PeekInputSelect, Object.assign({}, props, { items: selectPlan }));
};
export default CommunityPlanSelector;
